const dialcodeselect = {
    height: {
        value: '{space.relative.full.value}',
    },
};

export { dialcodeselect };
